import { CalendarView } from 'src/pages/Settings/signal-oncall-schedule/types';
import { getToolbarStepDateByView } from './dates-manipulation';

export function getToolbarNavigationDate(
  date: Date,
  view: CalendarView,
  direction: 'previous' | 'next',
): Date {
  return getToolbarStepDateByView(date, view, direction);
}
